var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 9.625,
    fill: "url(#paint0_linear_49_15)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5844 13.9436L15.012 11.2269H12.3373V9.46481C12.3373 8.72142 12.7103 7.99636 13.9082 7.99636H15.125V5.68356C15.125 5.68356 14.0212 5.5 12.9664 5.5C10.7627 5.5 9.32364 6.8014 9.32364 9.15643V11.2269H6.875V13.9436H9.32364V20.5112C9.81524 20.5865 10.3182 20.625 10.8305 20.625C11.3428 20.625 11.8457 20.5865 12.3373 20.5112V13.9436H14.5844Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_49_15",
    x1: 11,
    y1: 1.375,
    x2: 11,
    y2: 20.5679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18ACFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0163E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.7d0990b8ee64bff372fd8128ed4504ef.svg";
export { ForwardRef as ReactComponent };